import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './features241.css'

const Features241 = (props) => {
  const [activeTab, setActiveTab] = useState(0)
  return (
    <div className="thq-section-padding">
      <div className="features241-container2 thq-section-max-width">
        <div className="features241-image-container">
          {activeTab === 0 && (
            <img
              alt={props.imageAlt2}
              src={props.imageSrc2}
              className="features241-image1 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 1 && (
            <img
              alt={props.imageAlt3}
              src={props.imageSrc3}
              className="features241-image2 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 2 && (
            <img
              alt={props.imageAlt4}
              src={props.imageSrc4}
              className="features241-image3 thq-img-ratio-16-9"
            />
          )}
        </div>
        <div className="features241-tabs-menu">
          <div
            onClick={() => setActiveTab(0)}
            className="features241-tab-horizontal1"
          >
            <div className="features241-divider-container1">
              {activeTab === 0 && (
                <div className="features241-container3"></div>
              )}
            </div>
            <div className="features241-content1">
              <h2 className="features241-feature1-title thq-heading-2">
                {props.feature1Title ?? (
                  <Fragment>
                    <span className="features241-text11">
                      Diversity and Inclusion
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {props.feature1Description ?? (
                  <Fragment>
                    <span className="features241-text16">
                      <span>
                        Create an inclusive learning environment for all,
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>regardless of background</span>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            className="features241-tab-horizontal2"
          >
            <div className="features241-divider-container2">
              {activeTab === 1 && (
                <div className="features241-container4"></div>
              )}
            </div>
            <div className="features241-content2">
              <h2 className="features241-feature2-title thq-heading-2">
                {props.feature2Title ?? (
                  <Fragment>
                    <span className="features241-text20">
                      Excellence in Delivery
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {props.feature2Description ?? (
                  <Fragment>
                    <span className="features241-text12">
                      <span>
                        Maintain a high standard in the quality of our
                      </span>
                      <br></br>
                      <span>programs</span>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            className="features241-tab-horizontal3"
          >
            <div className="features241-divider-container3">
              {activeTab === 2 && (
                <div className="features241-container5"></div>
              )}
            </div>
            <div className="features241-content3">
              <h2 className="features241-feature3-title thq-heading-2">
                {props.feature3Title ?? (
                  <Fragment>
                    <span className="features241-text10">
                      Integrity and Trust
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {props.feature3Description ?? (
                  <Fragment>
                    <span className="features241-text21">
                      <span>Build long-term relationships based on trust,</span>
                      <br></br>
                      <span>transparency and ethical practices</span>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Features241.defaultProps = {
  feature3Title: undefined,
  feature1Title: undefined,
  feature2Description: undefined,
  imageSrc4:
    'https://images.unsplash.com/photo-1596633607590-7156877ef734?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8c2VhcmNofDF8fGdyZWV0aW5nfGVufDB8fHx8MTczNjk1MDQyOHww&ixlib=rb-4.0.3&q=80&w=1400',
  feature1Description: undefined,
  feature2Title: undefined,
  imageSrc2:
    'https://images.unsplash.com/photo-1549057446-9f5c6ac91a04?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE2fHxncm91cCUyMHN0dWRlbnRzfGVufDB8fHx8MTczNjk0OTQzOHww&ixlib=rb-4.0.3&q=80&w=1400',
  feature3Description: undefined,
  imageSrc3:
    'https://images.unsplash.com/photo-1508730328641-47c1616341b7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8c2VhcmNofDE1fHxhY2hpZXZlbWVudHxlbnwwfHx8fDE3MzY5NTAyNzB8MA&ixlib=rb-4.0.3&q=80&w=1400',
  imageAlt3: 'image',
  imageAlt2: 'image',
  imageAlt4: 'image',
}

Features241.propTypes = {
  feature3Title: PropTypes.element,
  feature1Title: PropTypes.element,
  feature2Description: PropTypes.element,
  imageSrc4: PropTypes.string,
  feature1Description: PropTypes.element,
  feature2Title: PropTypes.element,
  imageSrc2: PropTypes.string,
  feature3Description: PropTypes.element,
  imageSrc3: PropTypes.string,
  imageAlt3: PropTypes.string,
  imageAlt2: PropTypes.string,
  imageAlt4: PropTypes.string,
}

export default Features241
